import { useTranslation } from "react-i18next";
import { Send } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { NotificationReadinessSection } from "../NotificationReadinessSection";
import type { NotificationReadiness } from "../notification-types";

interface UserNotificationSectionProps {
  readonly phone?: string;
  readonly readiness: NotificationReadiness;
  readonly onSend: () => void;
}

/** Channel readiness plus the entry point of the ad-hoc notification dialog (admin + support). */
export function UserNotificationSection({
  phone,
  readiness,
  onSend,
}: UserNotificationSectionProps) {
  const { t } = useTranslation();
  return (
    <section data-testid="user-detail-notify" className="space-y-4">
      <NotificationReadinessSection phone={phone} readiness={readiness} />
      <Button data-testid="open-send-notification" variant="outline" onClick={onSend}>
        <Send className="mr-2 h-4 w-4" />
        {t("users.actions.sendNotification")}
      </Button>
    </section>
  );
}
